import invariant from 'fbjs/lib/invariant';

export {
  InteractiveBridge
};

/**
 * @todo Import messages types from bridge
 * @todo Fix eslint issue
 */
let interactiveWindow = null;
let messageHandlers = new Map();

function InteractiveBridge() {
  window.addEventListener('message', (event) => {
    try {
      onMessage(event);
    } catch (error) {
      console.error(error);
    }
  }, false);

  this.setWindow = (window) => {
    interactiveWindow = window;
  };

  this.create = send('create');

  this.start = send('start');
  this.stop = send('stop');
  this.resize = send('resize');
  this.time = send('time');
  this.pause = send('pause');
  this.resume = send('resume');
  this.action = send('action');

  this.onLoad = addHandler('loaded');
  this.onReady = addHandler('ready');
  this.onStart = addHandler('started');
  this.onStop = addHandler('stopped');
  this.onPause = addHandler('paused');
  this.onResume = addHandler('resumed');
  this.onShowElement = addHandler('showElement');
  this.onHideElement = addHandler('hideElement');
  this.onSetFocusable = addHandler('focusable');
  this.onBlur = addHandler('blur');
  this.onShowControls = addHandler('showControls');
  this.onHideControls = addHandler('hideControls');
  this.onClose = addHandler('close');
  this.onError = addHandler('error');
  this.onBroadcastEvent = addHandler('broadcast-event');
  this.onReceiveAction = addHandler('action');

  /**
   * Register internal handler for track-event's messages.
   * These messages, unlike broadcast's, well expected and should be handled without additional registration.
   */
  this.onTrackEvent = addHandler('track-event');
}

/**
 *
 * @param {string} pType
 * @return {(function({}=): void)|*}
 */
function send(pType) {
  /*
        if (process.env.NODE_ENV === 'development') {
          if ([
            'time',
            'resize'
          ].includes(pType) === false) {
            console.debug(`Send message "${pType}"`, pData);
          }
        }
        if (pType === 'start') {
          debugger;
        }
  */
  return function(pData = {}) {
      interactiveWindow.postMessage({
        type: 'interactive:' + pType,
        data: pData
      }, '*');
    };
  }

/**
 *
 * @param {string} messageType
 * @return {(function(*): void)|*}
 */
function addHandler(messageType) {
  return (handler) => {
    messageHandlers.set(`app:${messageType}`, handler);
  };
}

function onMessage(ev) {
  if (ev.source !== interactiveWindow) {
    return;
  }

  invariant(ev.data, 'No data in message');
  invariant(ev.data.type, 'No type in message.data');
  invariant(messageHandlers.has(ev.data.type), 'Unknown message type "%s"', ev.data.type);

  messageHandlers.get(ev.data.type)(ev.data);
}
